export default "__VITE_ASSET___NvliyPI__"